import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// import LandingPage from "./pages/LandingPage";
// import Home from "./pages/Home";
import SubLogin from './components/sub_login2';
import ContactForm from './components/contact_form';



function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<SubLogin />} />
        <Route path="/lets-talk" element={<ContactForm />} />
        

        {/* Other routes */}
        {/* <Route path="/home" element={<Home />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
